<div class="page-section series-form-page">
	<div class="app-l-page__navigation">
		<div class="app-l-page__previous" [routerLink]="['/app']">
			<button class="app-c-btn app-c-btn--icon app-c-btn--icon-secondary app-c-btn--icon-20">
				<svg-icon icon="arrow-left" class="w-100 h-100"></svg-icon>
			</button>
		</div>
		<div class="app-l-page__breadcrumbs">
			<ul class="breadcrumbs-list">
				<li class="breadcrumbs-list-item app-l-current-page">
					System Permission
				</li>
			</ul>
		</div>
	</div>

	<div class="page-section-content">
		<my-tabs>
			<!-- Permission Tab -->
			<my-tab tabTitle="Permission">
				<div class="tab-header">
					<h3>Permissions</h3>
					<button class="app-c-btn app-c-btn--primary app-c-btn--curve app-c-btn--with-icon"
						(click)="createPermission()">
						<svg-icon icon="plus" alt="plus"></svg-icon>
						<span>Create Permission</span>
					</button>
				</div>

				<div class="permission-grid">
					<article *ngFor="let role of roles; let roleIndex = index" class="permission-card">
						<header class="permission-card__header">
							<div class="permission-card__title-row">
								<h4 class="permission-card__title">{{ role.Name }}</h4>
								<span class="permission-card__count">
									{{ getEnabledCount(roleIndex) }} / {{ permission.length }}
								</span>
							</div>
							<label class="permission-card__select-all">
								<input type="checkbox"
									[checked]="role.isAllChecked"
									(change)="selectAllPermission($event, role)" />
								<span>Select all</span>
							</label>
						</header>
						<ul class="permission-card__list">
							<li *ngFor="let perm of permission; let permIndex = index">
								<label class="permission-card__item">
									<input type="checkbox"
										[checked]="allPermission[permIndex][roleIndex]?.PermissionValue"
										(change)="selectPermission($event, allPermission[permIndex][roleIndex])" />
									<span>{{ perm.Name }}</span>
								</label>
							</li>
						</ul>
					</article>
				</div>

				<div class="form-actions">
					<button class="app-c-btn app-c-btn--primary app-c-btn--curve"
						(click)="savePermission()">Save</button>
				</div>
			</my-tab>

			<!-- Config Tab -->
			<my-tab tabTitle="Config">
				<app-config-listing></app-config-listing>
			</my-tab>
		</my-tabs>
	</div>
</div>
